import { render } from "./SolarPanels.vue?vue&type=template&id=42d695ca"
import script from "./SolarPanels.vue?vue&type=script&lang=js"
export * from "./SolarPanels.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__